import type { MediaSoundProcessorOptions } from '@yandex-360/telemost-sdk/device-manager';
import { MediaSoundProcessorType } from '@yandex-360/telemost-sdk/device-manager';
import type { NoiseCancellationOptions, SoundProcessorOptions } from '@yandex-video-platform/goloom-sdk';
import { SoundProcessorType } from '@yandex-video-platform/goloom-sdk';

const mapNoiseCancellationFromGoloom = (
    value: boolean | NoiseCancellationOptions
): MediaSoundProcessorOptions['noiseCancellation'] => {
    if (typeof value === 'boolean') {
        return value;
    }

    switch (value.type) {
        case SoundProcessorType.RNNOISE:
            return { type: MediaSoundProcessorType.RNNOISE };
        default:
            return false;
    }
};

const mapNoiseCancellationToGoloom = (
    value: MediaSoundProcessorOptions['noiseCancellation']
): boolean | NoiseCancellationOptions => {
    if (typeof value === 'boolean') {
        return value;
    }

    switch (value.type) {
        case MediaSoundProcessorType.RNNOISE:
            return { type: SoundProcessorType.RNNOISE };
        case MediaSoundProcessorType.DEEP_FILTER:
            return false;
        default: {
            const unexpected: never = value;

            return unexpected;
        }
    }
};

export const mapSoundProcessorOptionsFromGoloom = (options: SoundProcessorOptions): MediaSoundProcessorOptions => ({
    noiseCancellation: mapNoiseCancellationFromGoloom(options.noiseCancellation),
    localVad: false,
    rms: false,
    dtmf: false,
});

export const mapSoundProcessorToGoloom = (options: MediaSoundProcessorOptions): SoundProcessorOptions => {
    return {
        noiseCancellation: mapNoiseCancellationToGoloom(options.noiseCancellation),
    };
};
